(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.he-fyc');
  roots.forEach(function (root) {
    if (root.dataset.fycInit) return;
    root.dataset.fycInit = '1';
    var base = (root.dataset.root || '').replace(/\/$/, '');
    function url(h) { return base + '/collections/' + h; }

    /* ✅ 已切换到 12 月独立集合（2026-06-13 建成，handle=january-garnet 系列） */
    var BS = {
      1:{s:'Garnet',c:'Deep red',sw:'#8B1A1A',h:'january-garnet',m:'devotion, warmth and quiet confidence',cl:'Crimson'},
      2:{s:'Amethyst',c:'Purple violet',sw:'#7B4F9E',h:'february-amethyst',m:'calm, clarity and regal stillness',cl:'Violet'},
      3:{s:'Aquamarine',c:'Soft blue',sw:'#7EC8C8',h:'march-aquamarine',m:'serenity, courage and open water',cl:'Seafoam'},
      4:{s:'Diamond',c:'Crystal clear',sw:'#E8E8E8',h:'april-diamond',m:'clarity, strength and timeless light',cl:'Starlit'},
      5:{s:'Emerald',c:'Rich green',sw:'#2E7D4F',h:'may-emerald',m:'renewal, growth and steady abundance',cl:'Verdant'},
      6:{s:'Pearl',c:'Ivory white',sw:'#F5F0E8',h:'june-pearl',m:'purity, poise and timeless grace',cl:'Moonlit'},
      7:{s:'Ruby',c:'Bright red',sw:'#C41E3A',h:'july-ruby',m:'passion, vitality and bold confidence',cl:'Scarlet'},
      8:{s:'Peridot',c:'Lime green',sw:'#9DB73B',h:'august-peridot',m:'lightness, renewal and fresh optimism',cl:'Meadow'},
      9:{s:'Sapphire',c:'Deep blue',sw:'#0F4C8A',h:'september-sapphire',m:'wisdom, focus and quiet truth',cl:'Indigo'},
      10:{s:'Opal',c:'Iridescent pink',sw:'#e58fa6',h:'october-opal',m:'imagination, hope and iridescent wonder',cl:'Rose'},
      11:{s:'Topaz',c:'Golden amber',sw:'#D4A017',h:'november-topaz',m:'warmth, generosity and golden cheer',cl:'Golden'},
      12:{s:'Turquoise',c:'Teal blue',sw:'#2E8B8B',h:'december-turquoise',m:'steadiness, calm and grounded clarity',cl:'Teal'}
    };
    /* Air 集合真实在用 handle = air-energy（2026-06-18 核实：wood-energy 已空 0 件，171 件 Air 产品在 air-energy） */
    var EL = {
      fire:{e:'Fire',c:'Embers and coral',sw:'#c0392b',sw2:'#e17a66',h:'fire-energy',mean:'Warm, bright and bold.',pal:['#c0392b','#d4753a','#b88a44']},
      earth:{e:'Earth',c:'Forest and gold',sw:'#6b8e3d',sw2:'#b8901f',h:'earth-energy',mean:'Grounded and enduring.',pal:['#6b8e3d','#8a6526','#b0a07f']},
      air:{e:'Air',c:'Crystal and violet',sw:'#cfd8dd',sw2:'#7b4f9e',h:'air-energy',mean:'Clear, light and open.',pal:['#cfd8dd','#e7ecec','#f4efe6']},
      water:{e:'Water',c:'Sea and moonlight',sw:'#2c6e9b',sw2:'#eae2d2',h:'water-energy',mean:'Deep, calm and luminous.',pal:['#2c6e9b','#7b4f9e','#cfd8dd']}
    };
    var ENERGY = {
      Aries:'Bold, radiant and first to arrive. You wear color like a declaration.',
      Taurus:'Grounded and sensual. You wear what feels as good as it looks.',
      Gemini:'Curious, luminous and always surprising. Your style speaks before you do.',
      Cancer:'Soft, intuitive and deeply feeling. You wear your heart on your lapel.',
      Leo:'Magnetic, golden and impossible to ignore. You walk in and the room rearranges itself.',
      Virgo:'Refined, precise and quietly elegant. Every detail is intentional.',
      Libra:'Graceful, balanced and effortlessly beautiful. You make harmony look easy.',
      Scorpio:'Depth, intensity and quiet magnetism. You wear color like a second skin.',
      Sagittarius:'Free, expansive and endlessly curious. Your style crosses every border.',
      Capricorn:'Composed, timeless and quietly powerful. You invest in pieces that last.',
      Aquarius:'Original, electric and ahead of your time. You set the trends, never follow them.',
      Pisces:'Dreamy, fluid and deeply romantic. You dress like a living poem.'
    };
    var GLYPH = { Aries:'♈',Taurus:'♉',Gemini:'♊',Cancer:'♋',Leo:'♌',Virgo:'♍',Libra:'♎',Scorpio:'♏',Sagittarius:'♐',Capricorn:'♑',Aquarius:'♒',Pisces:'♓' };
    var SIGNS = [
      ['Aries','♈','fire'],['Taurus','♉','earth'],['Gemini','♊','air'],['Cancer','♋','water'],
      ['Leo','♌','fire'],['Virgo','♍','earth'],['Libra','♎','air'],['Scorpio','♏','water'],
      ['Sagittarius','♐','fire'],['Capricorn','♑','earth'],['Aquarius','♒','air'],['Pisces','♓','water']
    ];
    var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var MONTH_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];

    /* R44 SET_OVERRIDE 24组策展套装已删(2026-07-04):死代码,唯一引用者 buildSet 也是死代码;线上套装=heRenderSet 镜像主推+随机搭配。要恢复策展须按"所见即所搭"重做(套装必须镜像主推)。 */

    /* R45 · 可变 set：祝福语 = 石 phrase + 签 trait(产品无关,石+签都在)。月→石短语 + 星座→气质短语,拼成一句。 */
    var STONE_PHRASE = { 1:'Garnet, deep and warm', 2:'Amethyst, a quiet violet', 3:'Aquamarine, calm as clear water', 4:'A clear stone, full of light', 5:'Emerald, alive and green', 6:'Pearl, soft and moonlit', 7:'Ruby, a warm and certain red', 8:'Peridot, bright and new-green', 9:'Sapphire, deep evening blue', 10:'Opal, shifting with the light', 11:'Topaz, warm honey gold', 12:'Turquoise, of sea and sky' };
    var SIGN_TRAIT = { Aries:'leaps first and dims slow', Taurus:'stays steady, warm, and unhurried', Gemini:'is never just one thing', Cancer:'feels everything, all the way down', Leo:'was born to catch the light', Virgo:'misses nothing, and loves the small details', Libra:'reaches for the lovely and the fair', Scorpio:'runs deeper than they look', Sagittarius:'is always halfway somewhere new', Capricorn:'climbs, patient as stone', Aquarius:'is one of a kind, on purpose', Pisces:'drifts somewhere lovely' };
    function heBlessing(sign, m, gift) {
      var s = STONE_PHRASE[m] + ', for the ' + sign + ' who ' + SIGN_TRAIT[sign] + '. Wear them close.';
      return gift ? s.replace('Wear them close.', 'A pair to give, close to the heart.') : s;
    }
    /* 星座色(coral)池的祝福语:用星座色名(e.c 如"Embers and coral")替代生辰石,配合主推位轮到 coral 款时分享卡镜像 */
    function heBlessingEl(sign, e, gift) {
      var s = (e && e.c ? e.c : 'Your colors') + ', for the ' + sign + ' who ' + SIGN_TRAIT[sign] + '. Wear them close.';
      return gift ? s.replace('Wear them close.', 'A pair to give, close to the heart.') : s;
    }

    function zodiac(m, d) {
      /* 每月「新星座」的起始日（index = m-1）。day < start = 上一星座（EARLY），day >= start = 本月新星座（LATE）。
         修复：旧表每月只列一个星座，月内 cusp 之后的日期全部 fall-through 成默认 Capricorn（约半数生日出错）。 */
      var START = [20, 19, 21, 20, 21, 21, 23, 23, 23, 23, 22, 22];
      var EARLY = ['Capricorn','Aquarius','Pisces','Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius'];
      var LATE  = ['Aquarius','Pisces','Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn'];
      var ELEM  = { Aries:'fire', Leo:'fire', Sagittarius:'fire', Taurus:'earth', Virgo:'earth', Capricorn:'earth', Gemini:'air', Libra:'air', Aquarius:'air', Cancer:'water', Scorpio:'water', Pisces:'water' };
      var sign = (d < START[m - 1]) ? EARLY[m - 1] : LATE[m - 1];
      return { sign: sign, el: ELEM[sign] };
    }

    var daySel = root.querySelector('.he-fyc__day');
    for (var i = 1; i <= 31; i++) {
      var o = document.createElement('option');
      o.value = i; o.textContent = i; daySel.appendChild(o);
    }

    root.querySelectorAll('.he-fyc__el').forEach(function (a) {
      a.setAttribute('href', url(a.dataset.h));
    });

    /* 星座 → 代表月(该星座大部分覆盖的月):点星座去该月生辰石集合,不去跨月的四元素集合。声明须在下方 [data-zodiac] 渲染块之前(原在色轮区,存在 var 提升 undefined 的 TypeError 地雷) */
    var SIGN_MONTH = { Aries: 4, Taurus: 5, Gemini: 6, Cancer: 7, Leo: 8, Virgo: 9, Libra: 10, Scorpio: 11, Sagittarius: 12, Capricorn: 1, Aquarius: 2, Pisces: 3 };

    var zEl = root.querySelector('[data-zodiac]');
    if (zEl) SIGNS.forEach(function (s) {
      var a = document.createElement('a');
      a.className = 'he-fyc__sign';
      a.href = url((BS[SIGN_MONTH[s[0]]] || {}).h || EL[s[2]].h);
      a.innerHTML = '<span class="he-fyc__glyph">' + s[1] + '\uFE0E</span>' +
        '<span class="he-fyc__sign-name">' + s[0] + '</span>' +
        '<span class="he-fyc__sign-el">' + EL[s[2]].e + '</span>';
      zEl.appendChild(a);
    });

    var mEl = root.querySelector('[data-months]');
    for (var m = 1; m <= 12; m++) {
      var b = BS[m];
      var a2 = document.createElement('a');
      a2.className = 'he-fyc__month-card';
      a2.setAttribute('data-bmonth', m);
      a2.href = url(b.h);
      a2.innerHTML = '<span class="he-fyc__month-gem"><svg viewBox="0 0 48 48" fill="none" aria-hidden="true">' +
        '<polygon points="13,6 35,6 42,13 42,35 35,42 13,42 6,35 6,13" fill="' + b.sw + '" stroke="#b88a44" stroke-width="1" stroke-linejoin="round"/>' +
        '<polygon points="17,11 31,11 37,17 37,31 31,37 17,37 11,31 11,17" fill="none" stroke="#b88a44" stroke-width="0.8" stroke-opacity="0.85" stroke-linejoin="round"/>' +
        '<polygon points="21,16 27,16 32,21 32,27 27,32 21,32 16,27 16,21" fill="none" stroke="#b88a44" stroke-width="0.8" stroke-opacity="0.85" stroke-linejoin="round"/>' +
        '</svg></span>' +
        '<span class="he-fyc__month-m">' + MONTHS[m - 1] + '</span>' +
        '<span class="he-fyc__month-s">' + b.s + '</span>';
      mEl.appendChild(a2);
    }
    /* —— R81 · 色彩之轮（替 Shop by element；分区可点→元素集合，输入后高亮你的星座）—— */
    var WHEEL = [['Capricorn','CAP','earth'],['Aquarius','AQU','air'],['Pisces','PIS','water'],['Aries','ARI','fire'],['Taurus','TAU','earth'],['Gemini','GEM','air'],['Cancer','CAN','water'],['Leo','LEO','fire'],['Virgo','VIR','earth'],['Libra','LIB','air'],['Scorpio','SCO','water'],['Sagittarius','SAG','fire']];
    var WCOL = { fire:'#d49a78', earth:'#a7bd79', air:'#a6c2cf', water:'#6f9fb0' };
    /* SIGN_MONTH 声明已上移到 [data-zodiac] 渲染块之前(修 var 提升地雷) */
    function wpt(d, rad) { var a = d * Math.PI / 180; return [280 + rad * Math.cos(a), 280 + rad * Math.sin(a)]; }
    function wseg(a1, a2, Ro, Ri) { var o1 = wpt(a1,Ro), o2 = wpt(a2,Ro), i2 = wpt(a2,Ri), i1 = wpt(a1,Ri); return 'M'+o1[0]+' '+o1[1]+' A'+Ro+' '+Ro+' 0 0 1 '+o2[0]+' '+o2[1]+' L'+i2[0]+' '+i2[1]+' A'+Ri+' '+Ri+' 0 0 0 '+i1[0]+' '+i1[1]+' Z'; }
    function buildWheel() {
      var w = root.querySelector('[data-wheel]'); if (!w) return;
      var R = 210, r = 128, svg = '';
      for (var i = 0; i < 12; i++) {
        var c = -90 + i * 30, b1 = c - 15, b2 = c + 15, s = WHEEL[i];
        var wsm = SIGN_MONTH[s[0]], wsh = (BS[wsm] && BS[wsm].h) ? BS[wsm].h : EL[s[2]].h;
        svg += '<a href="' + url(wsh) + '" class="he-fyc__wseg" data-wsign="' + s[0] + '" data-wmonth="' + wsm + '" aria-label="' + s[0] + ' · ' + (BS[wsm] ? BS[wsm].s : EL[s[2]].e) + '">';
        svg += '<path d="' + wseg(b1, b2, R, r) + '" fill="' + WCOL[s[2]] + '" stroke="#f7f3ea" stroke-width="2.5"/>';
        var lp = wpt(c, (R + r) / 2);
        svg += '<text x="' + lp[0] + '" y="' + (lp[1] - 3) + '" class="he-fyc__wlab">' + s[1] + '</text>';
        svg += '<text x="' + lp[0] + '" y="' + (lp[1] + 14) + '" class="he-fyc__wel">' + EL[s[2]].e + '</text></a>';
      }
      svg += '<circle cx="280" cy="280" r="' + (R + 8) + '" fill="none" stroke="#c6ab6e" stroke-width="1"/>';
      var tk = ''; for (var t = 0; t < 72; t++) { var ta = t * 5, big = (t % 6 === 0), p1 = wpt(ta, R + 8), p2 = wpt(ta, R + (big ? 2 : 5)); tk += '<line x1="' + p1[0] + '" y1="' + p1[1] + '" x2="' + p2[0] + '" y2="' + p2[1] + '" stroke="#c6ab6e" stroke-width="' + (big ? .9 : .5) + '" stroke-opacity="' + (big ? .8 : .45) + '"/>'; }
      svg += '<g class="he-fyc__wticks" style="pointer-events:none">' + tk + '</g>';
      svg += '<circle cx="280" cy="280" r="' + (r - 6) + '" fill="#faf7f0" stroke="#c6ab6e" stroke-width="1" style="pointer-events:none"/><circle cx="280" cy="280" r="' + (r - 16) + '" fill="none" stroke="#c6ab6e" stroke-width=".6" stroke-opacity=".5" style="pointer-events:none"/>';
      svg += '<g style="pointer-events:none"><path d="M280 244 l4 11.5 11.5-4 -7.5 9.5 7.5 9.5 -11.5-4 -4 11.5 -4-11.5 -11.5 4 7.5-9.5 -7.5-9.5 11.5 4 z" fill="#9a7526" opacity=".9"/>';
      svg += '<text x="280" y="294" class="he-fyc__wctr">THE LANGUAGE</text><text x="280" y="310" class="he-fyc__wctr">OF COLOR</text></g>';
      w.innerHTML = svg;
    }
    function highlightWheel(sign, m) {
      var w = root.querySelector('[data-wheel]'); if (!w) return;
      w.querySelectorAll('.he-fyc__wseg').forEach(function (a) {
        if (a.getAttribute('data-wsign') === sign) {
          a.classList.add('is-you');
          if (m && BS[m] && BS[m].h) a.setAttribute('href', url(BS[m].h));
        } else {
          a.classList.remove('is-you');
          var wm = a.getAttribute('data-wmonth'); if (wm && BS[wm] && BS[wm].h) a.setAttribute('href', url(BS[wm].h));
        }
      });
    }
    buildWheel();

    var giftToggle = root.querySelector('[data-gift-toggle]');
    var giftBody = root.querySelector('[data-gift-body]');
    if (giftToggle && giftBody) {
      giftToggle.addEventListener('click', function () {
        if (giftBody.hasAttribute('hidden')) { giftBody.removeAttribute('hidden'); giftToggle.textContent = 'Just for me →'; }
        else { giftBody.setAttribute('hidden', ''); giftToggle.textContent = 'Find a gift →'; }
      });
    }

    function setText(sel, t) { var n = root.querySelector(sel); if (n) n.textContent = t; }
    function setBg(sel, c) { var n = root.querySelector(sel); if (n) n.style.background = c; }
    function elGrad(e) { return (e && e.sw2) ? ('linear-gradient(135deg,' + e.sw + ' 0%,' + e.sw + ' 48%,' + e.sw2 + ' 52%,' + e.sw2 + ' 100%)') : (e ? e.sw : ''); }
    function setHref(sel, h) { var n = root.querySelector(sel); if (n) n.setAttribute('href', h); }
    /* collection products.json 价格是美元字符串("39.00")；product.js 是分(3900) */
    function money(p) {
      var n = (typeof p === 'string') ? parseFloat(p) : p / 100;
      return '$' + n.toFixed(2);
    }
    function toast(msg) {
      var el = document.querySelector('.he-toast');
      if (!el) { el = document.createElement('div'); el.className = 'he-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
      el.textContent = msg; el.classList.add('is-on');
      clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-on'); }, 2200);
    }

    /* —— 就地 ATC：add.js + Dawn section 重渲染（drawer + 角标） —— */
    function addToCart(vid, btn) {
      if (!vid) return;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(base + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
      }).then(function (r) { return r.json(); }).then(function (data) {
        btn.disabled = false; btn.textContent = label;
        if (data.status && data.status !== 200) { toast('Could not add, please try again'); return; }
        if (data.sections) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections['cart-drawer']) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data.sections['cart-drawer'];
            var fresh = tmp.querySelector('cart-drawer');
            if (fresh) drawer.outerHTML = fresh.outerHTML;
          }
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections['cart-icon-bubble']) {
            var tmp2 = document.createElement('div');
            tmp2.innerHTML = data.sections['cart-icon-bubble'];
            var freshBubble = tmp2.querySelector('#cart-icon-bubble') || tmp2.firstElementChild;
            if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
          }
        }
        toast('✓ Added to cart');
        if (window.fbq) { try { window.fbq('track', 'AddToCart'); } catch (e) {} }
      }).catch(function () { btn.disabled = false; btn.textContent = label; toast('Could not add, please try again'); });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-vid]');
      if (b && b.dataset.vid) { e.preventDefault(); addToCart(b.dataset.vid, b); }
    });

    /* —— 你的 edit：取生辰石集合产品，题材 chip 客户端收窄 —— */
    var editProducts = [];
    var currentMotif = '';
    var heUserEl = '', heUserM = '', MCODE = 'jan feb mar apr may jun jul aug sep oct nov dec'.split(' ');
    function heParams() { return ''; /* 2026-07-01 停用 ?he_el:PDP chip 改为永远显产品自身元素,避免生辰石款从火象访客链接进来被误显成 Fire */ }
    /* —— 选品引擎共享状态 + 取池设施(2026-07-04 上移到外层:支持生日输入期预取;hePickCombo/seenCombos 死代码已删) —— */
    var hePoolCache = {}, heEditOrder = {}, heEditCursor = {}, heLastHero = '', heEditExpanded = false, heHeroOrder = {}, heHeroCursor = {}, heRotRestored = {};
    var hePoolCacheEl = {}, heElHeroOrder = {}, heElHeroCursor = {}, heLastElHero = '', hePoolMode = {};
    var hePoolProm = {}, hePoolPromEl = {}, heRotRestoredEl = {}, heLastShown = '', heFeatRestore = null, heNextPair = {}, heSaCount = 0, heLastPair = '', heGoBusy = false;
    /* CDN 图按展示位缩尺寸(products.json 的 src 是原图;已带 width 的替换不叠加) */
    function heSized(u, w) { if (!u) return u; if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w); return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
    function heNorm(list) { return (list || []).map(function (p) { p.tags = (typeof p.tags === 'string') ? p.tags.split(', ') : (p.tags || []); return p; }); }
    function fcPage(h, pg) { return fetch(base + '/collections/' + h + '/products.json?limit=250&page=' + pg).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return j.products || []; }).catch(function () { return []; }); }
    /* 分页取全池:page1+page2 并行(全部池<250,原串行版必多等一次空 page2);page2 有新增才继续串行 → 保留防"端点砍50"设计 */
    function fc(h) {
      var acc = [], seen = {};
      function absorb(ps) { var added = 0; for (var i = 0; i < ps.length; i++) { if (!seen[ps[i].handle]) { seen[ps[i].handle] = 1; acc.push(ps[i]); added++; } } return added; }
      function step(pg) { return fcPage(h, pg).then(function (ps) { if (absorb(ps) === 0 || pg > 8) return acc; return step(pg + 1); }); }
      return Promise.all([fcPage(h, 1), fcPage(h, 2)]).then(function (two) {
        absorb(two[0]);
        if (absorb(two[1]) === 0) return acc;
        return step(3);
      }).then(function (all) { return heNorm(all.length ? all : (((window.HE_POOLS || {})[h]) || [])); });
    }
    /* 取池(promise 缓存):石池按月;元素池按元素名(同月跨两个星座,按月缓存会串池,如 8月1日Leo=fire、8月25日Virgo=earth) */
    function heStonePool(m) { if (!hePoolProm[m]) { hePoolProm[m] = fc(BS[m].h).then(function (p) { hePoolCache[m] = p; return p; }); } return hePoolProm[m]; }
    function heElPool(el) { if (!el || !EL[el]) return Promise.resolve([]); if (!hePoolPromEl[el]) { hePoolPromEl[el] = fc(EL[el].h).then(function (p) { hePoolCacheEl[el] = p; return p; }); } return hePoolPromEl[el]; }
    /* 生日一选就预取:用户填表那几秒网络不再闲着,点按钮时池子大概率已就绪 */
    function hePrefetch() {
      var mv = parseInt((root.querySelector('.he-fyc__month') || {}).value, 10);
      if (!mv || !BS[mv]) return;
      heStonePool(mv);
      var dv = parseInt((root.querySelector('.he-fyc__day') || {}).value, 10);
      if (dv) { var zz = zodiac(mv, dv); if (zz && zz.el) heElPool(zz.el); }
    }
    (function () { var _pm = root.querySelector('.he-fyc__month'), _pd = root.querySelector('.he-fyc__day'); if (_pm) _pm.addEventListener('change', hePrefetch); if (_pd) _pd.addEventListener('change', hePrefetch); })();
    /* 池子全空(fetch 失败+CDN兜底也空)的可见兜底:不再静默空白 */
    function heFycEmpty(mm) {
      var skel = root.querySelector('[data-fyc-skel]'); if (skel) skel.hidden = true;
      var fb = root.querySelector('[data-fyc-fallback]'); if (!fb) return;
      var cta = fb.querySelector('[data-fallback-cta]');
      if (cta && BS[mm]) { cta.setAttribute('href', url(BS[mm].h)); cta.textContent = 'Browse the ' + BS[mm].s + ' collection'; }
      fb.hidden = false;
    }
    /* 预载"下一件"的主推图(石池+星座色池各取游标处的下两位候选,覆盖 skip-guard 多走一步)→ 点 See another 时图已在 HTTP 缓存,秒换。低优先级+空闲时发起,不与当前渲染抢带宽 */
    function hePreloadNext(m) {
      try {
        var cands = [];
        var so = heHeroOrder[m] || [], sc = heHeroCursor[m] || 0;
        if (so[sc]) cands.push(so[sc]); if (so[sc + 1]) cands.push(so[sc + 1]);
        var eo = heElHeroOrder[m] || [], ec = heElHeroCursor[m] || 0;
        if (eo[ec]) cands.push(eo[ec]); if (eo[ec + 1]) cands.push(eo[ec + 1]);
        if (heNextPair[m] && heNextPair[m].p) cands.push(heNextPair[m].p);
        cands.forEach(function (p) {
          var u = (p && p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : '';
          if (u) { var im = new Image(); try { im.fetchPriority = 'low'; } catch (_fp) {} im.decoding = 'async'; im.src = heSized(u, 640); }
        });
      } catch (_e) {}
    }
    /* See another 的换图竞态:新主推图 decode 完成才恢复透明度(heFeature 里调用;2.2s 硬上限兜底) */
    function heFeatSettle(imEl) {
      if (!heFeatRestore) return;
      var done = heFeatRestore; heFeatRestore = null;
      var t = setTimeout(done, 2200);
      if (imEl && imEl.decode) { imEl.decode().catch(function () {}).then(function () { clearTimeout(t); done(); }); }
      else { clearTimeout(t); setTimeout(done, 400); }
    }
    function renderEdit() {
      var grid = root.querySelector('[data-fyc-grid]');
      if (!grid) return;
      var full = editProducts.filter(function (p) {
        return !currentMotif || (p.tags || []).indexOf(currentMotif) !== -1;
      });
      /* 选了具体题材时：纯题材款优先排前，跨题材款(会在别的 chip 重复出现的)排后 → 切 chip 撞见重复的概率降低。All 不排序，保持轮转 */
      if (currentMotif) {
        var HE_MO = ['animal', 'floral', 'statement', 'pearl'];
        full = full.slice().sort(function (a, b) {
          var na = (a.tags || []).filter(function (t) { return HE_MO.indexOf(t) >= 0; }).length;
          var nb = (b.tags || []).filter(function (t) { return HE_MO.indexOf(t) >= 0; }).length;
          return na - nb;
        });
      }
      var moreBtn = root.querySelector('[data-edit-more]');
      var list = full.slice(0, heEditExpanded ? 12 : 8);
      if (!list.length) {
        grid.innerHTML = '<p class="he-fyc__empty-edit">No ' + (currentMotif || '') + ' pieces in this palette yet. Try another style.</p>';
        if (moreBtn) moreBtn.hidden = true;
        return;
      }
      grid.innerHTML = list.map(function (p) {
        var img = heSized((p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : '', 480);
        var v = p.variants && p.variants[0];
        var avail = v && v.available !== false;
        return '<div class="he-fyc__p">' +
          '<a class="he-fyc__p-media" href="' + base + '/products/' + p.handle + heParams() + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true"><img src="' + img + '" alt="" loading="lazy" width="480" height="480"></a>' +
          '<a class="he-fyc__p-title" href="' + base + '/products/' + p.handle + heParams() + '" target="_blank" rel="noopener">' + p.title + '</a>' +
          '<p class="he-fyc__p-price">' + money(v ? v.price : p.price) + '</p>' +
          (avail
            ? '<button type="button" class="he-fyc__p-add" data-vid="' + (v ? v.id : '') + '">Quick add</button>'
            : '<button type="button" class="he-fyc__p-add" disabled>Sold out</button>') +
          '</div>';
      }).join('');
      if (moreBtn) { moreBtn.hidden = full.length <= 8; moreBtn.innerHTML = heEditExpanded ? 'Show less <span aria-hidden="true">&uarr;</span>' : 'Show more <span aria-hidden="true">&darr;</span>'; }
    }
    root.querySelectorAll('.he-fyc__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        root.querySelectorAll('.he-fyc__chip').forEach(function (c) { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); });
        chip.classList.add('is-on'); chip.setAttribute('aria-pressed', 'true');
        currentMotif = chip.dataset.motif || '';
        heEditExpanded = false;
        renderEdit();
      });
    });
    var editMoreBtn = root.querySelector('[data-edit-more]');
    if (editMoreBtn) editMoreBtn.addEventListener('click', function () { heEditExpanded = !heEditExpanded; renderEdit(); });
    /* loadEdit 已删(2026-07-04 死代码:旧 limit=50 单页取池,早被 heFycPick 双池引擎替代) */

    /* —— 套装：fetch 两件 + 渲染 + 一次加两件 —— */
    function addSet(vids, btn) {
      var ids = (vids || []).filter(Boolean);
      if (!ids.length) return;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(base + '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }), sections: 'cart-drawer,cart-icon-bubble' })
      }).then(function (r) { return r.json(); }).then(function (data) {
        btn.disabled = false; btn.textContent = label;
        if (data.status && data.status !== 200) { toast('Could not add, please try again'); return; }
        if (data.sections) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections['cart-drawer']) { var t = document.createElement('div'); t.innerHTML = data.sections['cart-drawer']; var f = t.querySelector('cart-drawer'); if (f) drawer.outerHTML = f.outerHTML; }
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections['cart-icon-bubble']) { var t2 = document.createElement('div'); t2.innerHTML = data.sections['cart-icon-bubble']; var fb = t2.querySelector('#cart-icon-bubble') || t2.firstElementChild; if (fb) bubble.innerHTML = fb.innerHTML; }
        }
        toast('✓ Set added. Free US shipping over $75');
        if (window.fbq) { try { window.fbq('track', 'AddToCart'); } catch (e) {} }
      }).catch(function () { btn.disabled = false; btn.textContent = label; toast('Could not add, please try again'); });
    }
    function setCard(p, label, isHero, pos) {
      var img = heSized(p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '', 640);
      var v = p.variants && p.variants[0];
      return { html: '<div class="he-fyc__set-card' + (isHero ? ' is-hero' : '') + '">' +
        (label ? '<p class="he-fyc__set-card-role">' + label + '</p>' : '') +
        '<a class="he-fyc__set-card-media" href="' + base + '/products/' + p.handle + heParams() + '" target="_blank" rel="noopener" tabindex="-1" aria-hidden="true">' + (isHero ? '<span class="he-fyc__set-saw he-fyc__set-saw--' + (pos || 'left') + '">the one you saw</span>' : '') + '<img src="' + img + '" alt="" loading="eager" fetchpriority="high" decoding="async" width="240" height="240"></a>' +
        '<p class="he-fyc__set-card-title"><a href="' + base + '/products/' + p.handle + heParams() + '" target="_blank" rel="noopener">' + p.title + '</a></p>' +
        '<p class="he-fyc__set-card-price">' + money(v ? v.price : p.price) + '</p>' +
        '</div>', vid: v ? v.id : '' };
    }
    /* buildSet 已删(2026-07-04 死代码:SET_OVERRIDE 取数路径,零调用;线上套装=heRenderSet) */

    /* —— R45 · 可变选品：石∪签池随机抽 hero + 对轴补 companion + edit 洗牌 —— */
    function heShuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
    function heRand(a) { return a[Math.floor(Math.random() * a.length)]; }
    function heFeature(p) {
      var fBox = root.querySelector('.he-fyc__feature'); if (!fBox || !p) return;
      var img = heSized((p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : '', 640);
      var v = p.variants && p.variants[0];
      var _fim = fBox.querySelector('.he-fyc__feature-media img');
      _fim.src = img;
      heFeatSettle(_fim);
      var fm = fBox.querySelector('.he-fyc__feature-media'); fm.setAttribute('href', base + '/products/' + p.handle + heParams()); fm.setAttribute('target', '_blank'); fm.setAttribute('rel', 'noopener');
      var t = fBox.querySelector('.he-fyc__feature-title'); t.textContent = p.title; t.setAttribute('href', base + '/products/' + p.handle + heParams()); t.setAttribute('target', '_blank'); t.setAttribute('rel', 'noopener');
      var rate = ((window.__heRatings || {})[p.handle]) || ((window.HE_RATINGS || {})[p.handle]), rEl = fBox.querySelector('.he-fyc__feature-rating');
      if (rEl) { if (rate && rate[1] > 0) { var full = Math.round(rate[0]), stars = ''; for (var si = 0; si < 5; si++) stars += (si < full ? '★' : '☆'); rEl.innerHTML = '<span class="he-fyc__rating-stars">' + stars + '</span> <span class="he-fyc__rating-num">' + rate[0] + ' (' + rate[1] + ')</span>'; rEl.hidden = false; } else { rEl.hidden = true; } }
      fBox.querySelector('.he-fyc__feature-price').textContent = money(v ? v.price : p.price);
      fBox.querySelector('.he-fyc__atc').dataset.vid = v ? v.id : '';
      fBox.hidden = false;
    }
    function heRenderSet(heroP, pairP, sign, m, gift, useEl, e) {
      var box = root.querySelector('.he-fyc__set'); if (!box) return;
      if (!heroP || !pairP) { box.hidden = true; return; }
      var gEl = root.querySelector('.he-set-glyph'); if (gEl) gEl.textContent = GLYPH[sign] + '︎';
      setText('.he-set-name', (gift ? 'Their ' : 'Your ') + sign + ' set');
      /* 套装镜像主推那件(featHero):左卡="the one you saw"=主推那件,右卡=搭配。coral 时文案/角色标签跟星座色(与主推、分享卡一致),避免"主推粉色 bouquet 却配 clear stone 文案+金色小鹿"的不一致 */
      var copyEl = root.querySelector('.he-set-copy'); if (copyEl) copyEl.textContent = useEl ? heBlessingEl(sign, e, gift) : heBlessing(sign, m, gift);
      var roles = gift ? [(useEl ? 'Their color' : 'Their stone'), 'Pairs with'] : [(useEl ? 'Your color' : 'Your stone'), 'Pairs with'];
      var c1 = setCard(heroP, roles[0], true, 'left');
      var c2 = setCard(pairP, roles[1], false, 'right');
      var pair = root.querySelector('[data-set-pair]'), addBtn = root.querySelector('[data-set-add]');
      if (pair) pair.innerHTML = c1.html + '<span class="he-fyc__set-plus" aria-hidden="true">+</span>' + c2.html;
      var vids = [c1.vid, c2.vid].filter(Boolean);
      if (addBtn) { if (vids.length) { addBtn.disabled = false; addBtn.onclick = function () { addSet(vids, addBtn); }; } else { addBtn.disabled = true; addBtn.onclick = null; } }
      box.hidden = false;
    }
    function heFycPick(m, d, z, e, gift) {
      heUserEl = z ? (z.el || '') : ''; heUserM = MCODE[m - 1] || '';
      /* 评价 map:Liquid 版最新鲜但被 Shopify 截断在每集合前50件 → pools.js 预生成的 HE_RATINGS 兜全量(大集合51+位的评价款不再被静默当无评价),Liquid 值优先覆盖 */
      var R = Object.assign({}, (window.HE_RATINGS || {}), (window.__heRatings || {}));
      function ok(p) { var v = p.variants && p.variants[0]; return v && p.images && p.images.length; }
      /* 选品池(软偏好):①售罄软过滤——密码期 available 全 false → live 空 → 回退全池(=现行为);上线后过滤真售罄,防售罄品当主推/进套装。②评价款≥12时评价款全留+未评价款轮转样本;配额同时挂钩评价款40%与未评价池25%(原只挂评价款,water 等大池新品曝光被压到个位数百分比) */
      function good(list) {
        var pool = list.filter(ok);
        var live = pool.filter(function (p) { var v = p.variants && p.variants[0]; return !v || v.available !== false; });
        if (live.length) pool = live;
        var rev = pool.filter(function (p) { return R[p.handle] && R[p.handle][1] > 0; });
        if (rev.length < 12) return pool;
        var unrev = pool.filter(function (p) { return !(R[p.handle] && R[p.handle][1] > 0); });
        return rev.concat(heShuffle(unrev).slice(0, Math.max(6, Math.ceil(rev.length * 0.4), Math.ceil(unrev.length * 0.25))));
      }
      function run(stonePool, elPool) {
        var skel = root.querySelector('[data-fyc-skel]'); if (skel) skel.hidden = true;
        var fb = root.querySelector('[data-fyc-fallback]'); if (fb) fb.hidden = true;
        var gS = good(stonePool);
        var gE = elPool ? good(elPool) : [];
        /* 石池空:两池都空 → 可见兜底;仅元素池有货 → 强制星座色框架(不许把跨月元素池产品配上月份文案) */
        var stoneEmpty = !gS.length;
        if (stoneEmpty && !gE.length) { heFycEmpty(m); return; }
        /* ② 回访恢复:本会话首次为该月从 localStorage 取回 hero/edit 轮转游标 → 回访自动接着走;产品增删按 handle 自愈 */
        if (!heRotRestored[m]) { heRotRestored[m] = 1; try {
          var _sv = JSON.parse((window.localStorage && localStorage.getItem('he_rot_' + m)) || 'null');
          if (_sv) {
            if (_sv.order && _sv.order.length) { var _bh = {}; gS.forEach(function (p) { _bh[p.handle] = p; }); var _ro = _sv.order.map(function (h) { return _bh[h]; }).filter(Boolean); if (_ro.length) { heHeroOrder[m] = _ro.concat(gS.filter(function (p) { return _sv.order.indexOf(p.handle) < 0; })); heHeroCursor[m] = (_sv.cur > heHeroOrder[m].length ? heHeroOrder[m].length : (_sv.cur || 0)); heLastHero = _sv.last || heLastHero; } }
            if (_sv.eorder && _sv.eorder.length) { var _bh2 = {}; stonePool.forEach(function (p) { _bh2[p.handle] = p; }); var _eo = _sv.eorder.map(function (h) { return _bh2[h]; }).filter(Boolean); if (_eo.length) { heEditOrder[m] = _eo.concat(stonePool.filter(function (p) { return _sv.eorder.indexOf(p.handle) < 0; })); heEditCursor[m] = (_sv.ecur > heEditOrder[m].length ? 0 : (_sv.ecur || 0)); } }
          }
        } catch (_e) {} }
        /* 星座色游标恢复与石池解耦(2026-07-04):首帧可能只有石池(元素池后到),等 gE 就绪那次再恢复,不再被 heRotRestored 一次性烧掉 */
        if (!heRotRestoredEl[m] && gE.length) { heRotRestoredEl[m] = 1; try {
          var _sv2 = JSON.parse((window.localStorage && localStorage.getItem('he_rot_' + m)) || 'null');
          if (_sv2 && _sv2.eeorder && _sv2.eeorder.length) { var _bh3 = {}; gE.forEach(function (p) { _bh3[p.handle] = p; }); var _eo3 = _sv2.eeorder.map(function (h) { return _bh3[h]; }).filter(Boolean); if (_eo3.length) { heElHeroOrder[m] = _eo3.concat(gE.filter(function (p) { return _sv2.eeorder.indexOf(p.handle) < 0; })); heElHeroCursor[m] = (_sv2.eecur > heElHeroOrder[m].length ? heElHeroOrder[m].length : (_sv2.eecur || 0)); heLastElHero = _sv2.elast || heLastElHero; } }
        } catch (_e3) {} }
        /* 主推位轮换:石款 ⇄ 星座色款(coral,抹月份)。2026-07-04 改:元素轮不再预抽石 hero(不烧游标 → 石款不再一半轮空);抽取除各自去重外再对照 heLastShown 跨池去重(石池与元素池有交集,如 2月紫 ⊆ air 池,原可连续两次同一件) */
        hePoolMode[m] = (hePoolMode[m] === 0) ? 1 : 0;
        var useEl = ((hePoolMode[m] === 1 || stoneEmpty) && gE.length > 0);
        var featHero = null;
        if (useEl) {
          if (!heElHeroOrder[m] || !heElHeroOrder[m].length || heElHeroCursor[m] >= heElHeroOrder[m].length) { heElHeroOrder[m] = heShuffle(gE); heElHeroCursor[m] = 0; }
          featHero = heElHeroOrder[m][heElHeroCursor[m]]; heElHeroCursor[m] = heElHeroCursor[m] + 1;
          if (featHero && (featHero.handle === heLastElHero || featHero.handle === heLastShown) && heElHeroOrder[m].length > 1) {
            if (heElHeroCursor[m] >= heElHeroOrder[m].length) { heElHeroOrder[m] = heShuffle(gE); heElHeroCursor[m] = 0; }
            featHero = heElHeroOrder[m][heElHeroCursor[m]]; heElHeroCursor[m] = heElHeroCursor[m] + 1;
          }
          if (featHero) { heLastElHero = featHero.handle; } else { useEl = false; }
        }
        if (!useEl) {
          if (!heHeroOrder[m] || !heHeroOrder[m].length || heHeroCursor[m] >= heHeroOrder[m].length) { heHeroOrder[m] = heShuffle(gS); heHeroCursor[m] = 0; }
          featHero = heHeroOrder[m][heHeroCursor[m]]; heHeroCursor[m] = heHeroCursor[m] + 1;
          /* 连续不重复保险:与上次石 hero 或上次实际展示同 → 取下一个 */
          if (featHero && (featHero.handle === heLastHero || featHero.handle === heLastShown) && heHeroOrder[m].length > 1) {
            if (heHeroCursor[m] >= heHeroOrder[m].length) { heHeroOrder[m] = heShuffle(gS); heHeroCursor[m] = 0; }
            featHero = heHeroOrder[m][heHeroCursor[m]]; heHeroCursor[m] = heHeroCursor[m] + 1;
          }
          if (!featHero) { heFycEmpty(m); return; }
          heLastHero = featHero.handle;
        }
        heLastShown = featHero.handle;
        /* 搭配件(右 Pairs with):石池随机一件不同的(元素模式下只作 setPair 回退) */
        var rest = gS.filter(function (p) { return p.handle !== featHero.handle; });
        var other = rest.length ? heRand(rest) : featHero;
        heFeature(featHero);
        /* 分享卡/壁纸 canvas 重画要现拉 1600 大图,推迟到空闲执行 → 不与套装/网格图抢带宽(分享区在页面下方,延迟无感;连点时 FIFO 最后一次为准) */
        (function (fh, ue) {
          var draw = function () {
            if (root.querySelector('.he-fyc__share-canvas')) heDrawCard(z.sign, m, e, gift, fh, ue);
            if (root.querySelector('.he-fyc__wall-canvas')) heDrawWall(z.sign, m, e, gift, fh, ue);
          };
          if (window.requestIdleCallback) { requestIdleCallback(draw, { timeout: 2000 }); } else { setTimeout(draw, 600); }
        })(featHero, useEl);
        setText('.he-feature-why', useEl ? ('From ' + (gift ? 'their ' : 'your ') + z.sign + ' colors.') : ('From ' + (gift ? 'their ' : 'your ') + ((BS[m] && BS[m].s) ? BS[m].s : z.sign) + ' edit.'));
        /* Set 套装镜像主推(所见即所搭);coral 池只1件则回退石搭配。搭配件优先用上一轮预挑+预载好的(heNextPair,图已在缓存=Pairs with 秒出);模式不符/撞主推则回退现场随机 */
        var setPair = (function () {
          var pre = heNextPair[m]; heNextPair[m] = null;
          if (pre && pre.p && pre.el === useEl && pre.p.handle !== featHero.handle) return pre.p;
          return useEl ? (function () { var eRest = gE.filter(function (p) { return p.handle !== featHero.handle; }); return eRest.length ? heRand(eRest) : other; })() : other;
        })();
        heLastPair = setPair.handle;
        window.__heFycMode = useEl ? 'element' : 'stone';
        heRenderSet(featHero, setPair, z.sign, m, gift, useEl, e);
        /* Edit grid: rotating cursor;过 ok()(原用裸 stonePool,无图品会出破图卡) */
        var excl = [featHero.handle, setPair.handle];
        var stoneOk = stonePool.filter(ok);
        if (!heEditOrder[m]) { heEditOrder[m] = heShuffle(stoneOk.slice()); heEditCursor[m] = 0; }
        var ord = heEditOrder[m], cur = heEditCursor[m] || 0;
        var nextSet = [], scanned = 0;
        while (nextSet.length < 12 && scanned < ord.length) {
          var pp = ord[(cur + scanned) % ord.length]; if (excl.indexOf(pp.handle) < 0) nextSet.push(pp); scanned++;
        }
        var newCur = (cur + scanned) % ord.length;
        if (newCur <= cur && ord.length > 12) { heEditOrder[m] = heShuffle(stoneOk.slice()); heEditCursor[m] = 0; } else { heEditCursor[m] = newCur; }
        /* ② 存轮转游标(回访接着走) */
        try { if (window.localStorage) localStorage.setItem('he_rot_' + m, JSON.stringify({ order: (heHeroOrder[m] || []).map(function (p) { return p.handle; }), cur: heHeroCursor[m] || 0, last: heLastHero || '', eorder: (heEditOrder[m] || []).map(function (p) { return p.handle; }), ecur: heEditCursor[m] || 0, eeorder: (heElHeroOrder[m] || []).map(function (p) { return p.handle; }), eecur: heElHeroCursor[m] || 0, elast: heLastElHero || '' })); } catch (_e2) {}
        editProducts = nextSet.concat(heShuffle(stoneOk.filter(function (p) { return excl.indexOf(p.handle) < 0 && nextSet.indexOf(p) < 0; })));
        var editBox = root.querySelector('.he-fyc__edit'); if (editBox) editBox.hidden = false;
        heEditExpanded = false;
        renderEdit();
        /* 预挑下一轮的搭配件(随机分布不变,只是提前抽签→图可预载):下一轮模式=本轮 toggle 后再翻一次;从对应池排除下一位主推候选后随机一件 */
        var nextUseEl = (hePoolMode[m] === 0) && gE.length > 0;
        var nextPool = nextUseEl ? gE : gS;
        var nextHeroCand = nextUseEl ? ((heElHeroOrder[m] || [])[heElHeroCursor[m] || 0]) : ((heHeroOrder[m] || [])[heHeroCursor[m] || 0]);
        var _nh = nextHeroCand ? nextHeroCand.handle : '';
        var _pr = nextPool.filter(function (p) { return p.handle !== _nh && p.handle !== heLastPair; });
        if (!_pr.length) _pr = nextPool.filter(function (p) { return p.handle !== _nh; });
        heNextPair[m] = _pr.length ? { p: heRand(_pr), el: nextUseEl } : null;
        /* 空闲时预载下一件主推图 + 预挑搭配件的图(See another 秒换的关键) */
        if (window.requestIdleCallback) { requestIdleCallback(function () { hePreloadNext(m); }, { timeout: 1500 }); } else { setTimeout(function () { hePreloadNext(m); }, 400); }
      }
      /* 池编排(2026-07-04):promise 缓存(生日输入期已预取则直接命中);首帧不等元素池 —— 石池到即渲染,元素池后台就位供下轮 See another 切星座色 */
      var elName = (z && z.el && EL[z.el]) ? z.el : '';
      var haveStone = !!hePoolCache[m];
      var haveEl = !elName || (hePoolCacheEl[elName] !== undefined);
      if (haveStone && haveEl) { run(hePoolCache[m], elName ? hePoolCacheEl[elName] : []); return; }
      var skel0 = root.querySelector('[data-fyc-skel]'), fBox0 = root.querySelector('.he-fyc__feature');
      if (skel0 && (!fBox0 || fBox0.hidden)) skel0.hidden = false;
      if (elName) heElPool(elName);
      heStonePool(m).then(function (stone) {
        if (elName && hePoolCacheEl[elName] !== undefined) { run(stone, hePoolCacheEl[elName]); }
        else { run(stone, []); }
      });
    }

    var giftModeOn = false;
    function gp(s) { return s.replace(/\bYou\b/g, 'They').replace(/\byou\b/g, 'they').replace(/\bYour\b/g, 'Their').replace(/\byour\b/g, 'their'); }
    /* —— 揭示 —— */
    function reveal(m, d, scroll) {
      var gift = giftModeOn;
      var b = BS[m];
      setText('.he-bs-context', MONTH_FULL[m - 1] + '’s birthstone');
      setBg('.he-bs-swatch', b.sw);
      setText('.he-bs-name', b.s);
      setText('.he-bs-meta', b.cl);
      setText('.he-bs-mean', b.m.charAt(0).toUpperCase() + b.m.slice(1) + '.');
      var z = zodiac(m, d), e = EL[z.el];
      var elLow = e.e.toLowerCase();
      setText('.he-zo-context', z.sign + ' is ' + (/^[aeiou]/.test(elLow) ? 'an' : 'a') + ' ' + elLow + ' sign');
      setBg('.he-zo-swatch', elGrad(e));
      setText('.he-zo-name', e.e);
      setText('.he-zo-meta', e.c);
      setText('.he-zo-mean', e.mean);
      /* 读屏播报一句摘要(代替原整容器 aria-live) */
      var __ann = root.querySelector('[data-fyc-announce]');
      if (__ann) __ann.textContent = (gift ? 'Their colors: ' : 'Your colors: ') + MONTH_FULL[m - 1] + ' birthstone ' + b.s + '. ' + z.sign + ', ' + e.e + ' energy.';
      setText('.he-made-glyph', GLYPH[z.sign] + '\uFE0E');
      setText('.he-made-name', z.sign);
      setText('.he-made-energy', gift ? gp(ENERGY[z.sign]) : ENERGY[z.sign]);
      setText('.he-feature-why', 'From ' + (gift ? 'their ' : 'your ') + b.s + ' edit.');
      setText('.he-fyc__made-kicker', gift ? 'They are' : 'You are');
      setText('.he-fyc__cards-label', gift ? 'Their palette' : 'Your palette');
      setText('.he-feature-kicker', gift ? 'Made for them' : 'Made for you');
      setText('.he-edit-poss', gift ? 'their' : 'your');
      setText('.he-fyc__set-kicker', gift ? 'Their sign · Their stone · Their story' : 'Your sign · Your stone · Your story');
      var closeCta = root.querySelector('.he-closing-cta');
      if (closeCta) { closeCta.setAttribute('href', url(b.h)); closeCta.textContent = gift ? 'Shop their colors' : 'Shop your colors'; }
      var rStone = root.querySelector('.he-read-stone');
      if (rStone) rStone.setAttribute('href', base + '/blogs/journal/find-your-colors-a-birthstone-color-guide');
      setText('.he-read-stone-t', 'The meaning of ' + b.s);
      setBg('.he-read-stone-block', b.sw);
      var rdEl = root.querySelector('.he-read-element');
      if (rdEl) rdEl.setAttribute('href', base + '/blogs/journal/dress-by-the-stars-zodiac-element-colors');
      setText('.he-read-element-t', 'Colors for ' + e.e + ' signs');
      setBg('.he-read-element-block', elGrad(e));
      setText('.he-fyc__reading-title', gift ? 'Keep reading, for them' : 'Keep reading, for you');
      var rsSub = root.querySelector('.he-read-stone .he-fyc__read-sub'); if (rsSub) rsSub.textContent = gift ? 'Their stone' : 'Your stone';
      var reSub = root.querySelector('.he-read-element .he-fyc__read-sub'); if (reSub) reSub.textContent = gift ? 'Their element' : 'Your element';
      setBg('.he-save-dot-stone', b.sw);
      setBg('.he-save-dot-el', elGrad(e));
      setText('.he-fyc__save-title', 'Save ' + (gift ? 'their ' : 'your ') + z.sign + ' palette');
      setText('.he-fyc__save-sub', gift ? 'Their palette, plus a reminder before their birthday.' : 'Your palette, sent straight to your inbox.');
      /* 礼物态：CTA / 说明 / 成功语一并切成"收礼人 + 提醒"口径（提交时数据线也切到 GiftBirthday，不碰买家自己的 Birthday） */
      setText('.he-fyc__save-form button[type="submit"]', gift ? 'Remind me for their birthday' : 'Save my palette');
      /* 复位存色板表单：换结果 / 再查一次时重新露出表单、隐藏上次的成功·错误提示、解锁按钮（否则上次保存后 saveForm 一直 hidden、按钮卡在 Saving…） */
      var __sfReset = root.querySelector('.he-fyc__save-form'); if (__sfReset) __sfReset.hidden = false;
      var __sokReset = root.querySelector('.he-fyc__save-ok'); if (__sokReset) __sokReset.hidden = true;
      var __serrReset = root.querySelector('.he-fyc__save-err'); if (__serrReset) __serrReset.hidden = true;
      var __sbtnReset = root.querySelector('.he-fyc__save-form button[type="submit"]'); if (__sbtnReset) __sbtnReset.disabled = false;
      var __promo;
      if (gift) {
        /* 智能月份：收礼人生日今年已过 → 自动说 "next [Month]"（因为提醒是按年循环，今年那次已错过，下一次在明年）。用 "their [Month] birthday" 措辞，避免 "before March" 在已进入 3 月时读错。 */
        var __t = new Date(), __tm = __t.getMonth() + 1, __td = __t.getDate();
        var __passed = (__tm > m) || (__tm === m && __td > d);
        __promo = 'We’ll remind you before their ' + (__passed ? 'next ' : '') + MONTH_FULL[m - 1] + ' birthday — plus 8% off your first order.';
      } else {
        /* Self 态：时间中性 + 惊喜口吻（自己的生日不用"提醒"）——顺带给"当月生辰石"流引流 */
        __promo = 'Save your palette for 8% off your first order — plus a little something each year on your birthstone month.';
      }
      setText('.he-fyc__save-promo', __promo);
      setText('.he-fyc__save-trust', gift ? 'One reminder before their birthday. No spam, unsubscribe anytime.' : 'One email, your colors. No spam, unsubscribe anytime.');
      setText('.he-fyc__save-ok', gift ? '✓ Saved. We’ll remind you before their birthday — your 8% code is on its way.' : '✓ Saved. Your 8% off code is on its way to your inbox.');
      /* 分享/留存块 + 阅读卡 + 相关 CTA：礼物态一并切成"他们的颜色"；分享/锁屏是买家自己设备上的动作，用中性词，避免语义错误的"their" */
      setText('.he-fyc__share-eyebrow', gift ? 'Take their colors with you' : 'Take your colors with you');
      setText('.he-fyc__share-keeptitle', gift ? 'Their colors, to share or keep' : 'Your colors, to share or keep');
      setText('.he-fyc__share-sub', gift ? 'One to share, one to keep — both free to download.' : 'One made for your story, one made for your lock screen. Both yours, free to download.');
      setText('.he-fyc__welcome', gift ? 'Save their palette below for 8% off your first order.' : 'Save your palette below for 8% off your first order.');
      var __kcaps = root.querySelectorAll('.he-fyc__keep-cap');
      if (__kcaps[0]) __kcaps[0].textContent = gift ? 'Share their card' : 'Share to your story';
      if (__kcaps[1]) __kcaps[1].textContent = gift ? 'Keep as a wallpaper' : 'Set as your lock screen';
      var __seeA = root.querySelector('.he-fyc__seeanother');
      if (__seeA && __seeA.firstChild && __seeA.firstChild.nodeType === 3) __seeA.firstChild.nodeValue = gift ? 'See another in their palette ' : 'See another in your palette ';
      var __wearT = root.querySelector('.he-fyc__read-title:not(.he-read-stone-t):not(.he-read-element-t)');
      if (__wearT) __wearT.textContent = gift ? 'How to wear their brooch' : 'How to wear your brooch';
      highlightWheel(z.sign, m);
      setText('[data-wheel-state]', (gift ? 'They sit in ' : 'You sit in ') + e.e + ' · the ' + z.sign + ' hour');
      root.querySelectorAll('[data-bmonth]').forEach(function (x) {
        var youOn = x.getAttribute('data-bmonth') === String(m);
        x.classList.toggle('is-you', youOn);
        var ytag = x.querySelector('.he-fyc__month-you');
        if (youOn) { if (!ytag) { ytag = document.createElement('span'); ytag.className = 'he-fyc__month-you'; x.appendChild(ytag); } ytag.textContent = gift ? 'Theirs' : 'Yours'; }
        else if (ytag) { ytag.remove(); }
      });
      var msub = root.querySelector('[data-months-sub]');
      if (msub) msub.textContent = (gift ? 'Theirs' : 'Yours') + ' is ' + MONTH_FULL[m - 1] + '’s ' + b.s + '. See it lit below, among all twelve.';
      var res = root.querySelector('.he-fyc__result');
      res.hidden = false;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        res.classList.remove('is-revealing'); void res.offsetWidth; res.classList.add('is-revealing');
      }
      var __lbl = root.querySelector('.he-edit-label'); if (__lbl) __lbl.textContent = MONTH_FULL[m - 1] + ' \xB7 ' + ((BS[m] && BS[m].s) ? BS[m].s : e.e);
      if (scroll) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.__heFyc = { m: m, d: d, sign: z.sign, stone: b.s, element: e.e, gift: gift };
      var __sb = root.querySelector('.he-fyc__share'); if (__sb) { __sb.hidden = false; heDrawCard(z.sign, m, e, gift); heDrawWall(z.sign, m, e, gift); }
      heFycPick(m, d, z, e, gift);
      /* 测验完成事件（§12.7 投放前自定义事件） */
      if (window.fbq) { try { window.fbq('trackCustom', 'FYCComplete', { sign: z.sign, month: m }); } catch (err) {} }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'he_fyc_complete', fyc_sign: z.sign, fyc_month: m });
    }

    root.querySelector('.he-fyc__go').addEventListener('click', function () {
      if (heGoBusy) return; heGoBusy = true; setTimeout(function () { heGoBusy = false; }, 600);
      var m = parseInt(root.querySelector('.he-fyc__month').value, 10);
      var d = parseInt(root.querySelector('.he-fyc__day').value, 10);
      var err = root.querySelector('.he-fyc__err');
      if (!m || !d) { if (err) err.hidden = false; return; }
      var _dm = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m - 1];
      if (d > _dm) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      reveal(m, d, true);
    });

    /* #4 See another：用当前 m/d 重推 z,e → 重调 heFycPick（重选 hero+套装，随机出新的）+ 轻 fade。守"发现"非拉霸：无计数/连胜 */
    var saBtn = root.querySelector('[data-seeanother]');
    if (saBtn) {
      saBtn.addEventListener('click', function () {
        var st = window.__heFyc; if (!st || !st.m) return;
        var z2 = zodiac(st.m, st.d), e2 = EL[z2.el];
        var fBox = root.querySelector('.he-fyc__feature'); if (fBox) fBox.style.opacity = '0.4';
        /* 恢复透明度交给 heFeatSettle(新主推图 decode 完成时);3s 硬上限兜底(池子还在取时也不至于一直暗) */
        heFeatRestore = function () { if (fBox) fBox.style.opacity = '1'; };
        setTimeout(function () { if (heFeatRestore) { var _f = heFeatRestore; heFeatRestore = null; _f(); } }, 3000);
        heFycPick(st.m, st.d, z2, e2, giftModeOn);
        /* 选品引擎唯一的效果仪表盘:第几次轮换 + 本轮模式(石/星座色),投放后据此调变化频率与双池配比 */
        heSaCount++;
        heTrack('he_fyc_see_another', 'FYCSeeAnother', { n: heSaCount, sign: st.sign || '', month: st.m, mode: window.__heFycMode || '' });
      });
    }

    /* #2 Color Card：canvas 直接画卡（纯形状+文字，无产品图=不踩跨域污染，canvas 本身即可下载的图） */
    function heWrapText(ctx, text, x, y, maxW, lh) {
      var words = (text || '').split(' '), line = '', lines = [];
      for (var n = 0; n < words.length; n++) { var test = line + words[n] + ' '; if (ctx.measureText(test).width > maxW && n > 0) { lines.push(line.trim()); line = words[n] + ' '; } else { line = test; } }
      lines.push(line.trim());
      var startY = y - ((lines.length - 1) * lh) / 2;
      for (var i = 0; i < lines.length; i++) ctx.fillText(lines[i], x, startY + i * lh);
    }
    function heTrack(ev, fbEv, params) { params = params || {}; try { if (window.fbq) window.fbq('trackCustom', fbEv, params); } catch (e) {} window.dataLayer = window.dataLayer || []; var o = { event: ev }; for (var k in params) o[k] = params[k]; window.dataLayer.push(o); }
    function heHiRes(u) { if (!u) return u; if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$11600'); return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=1600'; }
    function heDrawCard(sign, m, e, gift, hero, useEl) {
      var cv = root.querySelector('.he-fyc__share-canvas'); if (!cv) return;
      var ctx = cv.getContext('2d'); var W = 1080, H = 1920, SC = (cv.width || 1080) / 1080;
      var serifF = '"Playfair Display", Georgia, "Times New Roman", serif';
      var stc = (BS[m] && BS[m].sw) || '#9a7526', elc = (e && e.sw) || '#9a7526';
      var gold = '#9a7526', goldL = 'rgba(154,117,38,.5)', green = '#315f55', ink = '#20201f', muted = '#8a8472';
      function rr(x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }
      function paint(imgEl) {
        ctx.setTransform(SC, 0, 0, SC, 0, 0);
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#faf6ee'; ctx.fillRect(0, 0, W, H);
        ctx.strokeStyle = gold; ctx.lineWidth = 3; ctx.strokeRect(46, 46, W - 92, H - 92);
        ctx.strokeStyle = goldL; ctx.lineWidth = 1.5; ctx.strokeRect(72, 72, W - 144, H - 144);
        ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = green; ctx.font = '600 50px ' + serifF; ctx.fillText('Veyamoon', W / 2, 156);
        ctx.fillStyle = gold; ctx.font = '26px Helvetica, Arial, sans-serif';
        if ('letterSpacing' in ctx) ctx.letterSpacing = '7px';
        ctx.fillText('FIND YOUR COLORS', W / 2, 210);
        if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
        ctx.fillStyle = gold; ctx.font = '84px ' + serifF; ctx.fillText((GLYPH[sign] || '') + '︎', W / 2, 312);
        ctx.fillStyle = ink; ctx.font = '70px ' + serifF; ctx.fillText(sign, W / 2, 390);
        ctx.fillStyle = muted; ctx.font = '32px Helvetica, Arial, sans-serif'; ctx.fillText('born in ' + (MONTH_FULL[m - 1] || ''), W / 2, 440);
        var ix = 270, iy = 500, iw = 540, ih = 540, r = 16;
        ctx.save(); rr(ix, iy, iw, ih, r); ctx.fillStyle = imgEl ? '#100f0d' : '#ece6da'; ctx.fill(); ctx.clip();
        if (imgEl) { var s = Math.max(iw / imgEl.width, ih / imgEl.height); var dw = imgEl.width * s, dh = imgEl.height * s; ctx.drawImage(imgEl, ix + (iw - dw) / 2, iy + (ih - dh) / 2, dw, dh); }
        ctx.restore();
        rr(ix, iy, iw, ih, r); ctx.strokeStyle = goldL; ctx.lineWidth = 2; ctx.stroke();
        ctx.fillStyle = ink; ctx.font = '40px ' + serifF;
        heWrapText(ctx, (hero && hero.title) || '', W / 2, 1132, 840, 52);
        var lw2 = 360, lx2 = W / 2 - lw2 / 2, ly2 = 1262, lg2 = ctx.createLinearGradient(lx2, 0, lx2 + lw2, 0);
        lg2.addColorStop(0, 'rgba(154,117,38,0)'); lg2.addColorStop(0.14, stc); lg2.addColorStop(0.5, elc); lg2.addColorStop(0.86, gold); lg2.addColorStop(1, 'rgba(154,117,38,0)');
        ctx.fillStyle = lg2; ctx.fillRect(lx2, ly2 - 2, lw2, 4);
        ctx.fillStyle = '#5a564b'; ctx.font = 'italic 37px ' + serifF;
        heWrapText(ctx, useEl ? heBlessingEl(sign, e, gift) : heBlessing(sign, m, gift), W / 2, 1420, 820, 52);
        ctx.fillStyle = gold; ctx.beginPath(); ctx.moveTo(W / 2, 1686); ctx.lineTo(W / 2 + 13, 1700); ctx.lineTo(W / 2, 1714); ctx.lineTo(W / 2 - 13, 1700); ctx.closePath(); ctx.fill();
        ctx.fillStyle = green; ctx.font = '42px ' + serifF; ctx.fillText('Find your colors', W / 2, 1766);
        ctx.fillStyle = gold; ctx.font = '32px Helvetica, Arial, sans-serif';
        if ('letterSpacing' in ctx) ctx.letterSpacing = '4px';
        ctx.fillText('veyamoon.com', W / 2, 1822);
        if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
      }
      var heShareImg = null;
      /* generation token:慢网下旧 hero 的图迟到会把新卡画回旧内容(2026-07-08 审计) */
      heDrawCard._g = (heDrawCard._g || 0) + 1; var __g = heDrawCard._g;
      paint(null);
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { if (__g === heDrawCard._g) paint(heShareImg); }); }
      var imgUrl = hero && hero.images && (hero.images[0] ? (hero.images[0].src || hero.images[0]) : '');
      if (imgUrl) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { if (__g !== heDrawCard._g) return; heShareImg = im; paint(im); }; im.onerror = function () {}; im.src = heHiRes(imgUrl); }
    }
    function heDrawWall(sign, m, e, gift, hero, useEl) {
      var cv = root.querySelector('.he-fyc__wall-canvas'); if (!cv) return;
      var ctx = cv.getContext('2d'); var W = 1290, H = 2796;
      var serifF = '"Playfair Display", Georgia, "Times New Roman", serif';
      var stc = (BS[m] && BS[m].sw) || '#9a7526', elc = (e && e.sw) || '#6fa6ae';
      var stone = (BS[m] && BS[m].s) || '', elName = (e && e.e) || '';
      function paint(imgEl) {
        /* 采样产品图四角判黑底/白底 → 壁纸底/抠图/文字自适应(白底产品不再显刺眼白块) */
        var whiteBg = false;
        if (imgEl) { try { var sc = document.createElement('canvas'); sc.width = 40; sc.height = 40; var sx = sc.getContext('2d'); sx.drawImage(imgEl, 0, 0, 40, 40); var sd = sx.getImageData(0, 0, 40, 40).data, L = 0, N = 0, CS = [[0, 0], [32, 0], [0, 32], [32, 32]]; for (var c = 0; c < 4; c++) { for (var yy = CS[c][1]; yy < CS[c][1] + 8; yy++) for (var xx = CS[c][0]; xx < CS[c][0] + 8; xx++) { var q = (yy * 40 + xx) * 4; L += 0.2126 * sd[q] + 0.7152 * sd[q + 1] + 0.0722 * sd[q + 2]; N++; } } whiteBg = (L / N) > 150; } catch (e0) {} }
        var bg = ctx.createLinearGradient(0, 0, 0, H);
        if (whiteBg) { bg.addColorStop(0, '#f2ede2'); bg.addColorStop(0.5, '#e9e0cf'); bg.addColorStop(1, '#e4d9c4'); }
        else { bg.addColorStop(0, '#111a18'); bg.addColorStop(0.5, '#070705'); bg.addColorStop(1, '#0b0b08'); }
        ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
        if (imgEl) {
          var pw = 950, ph = 1120, px = (W - pw) / 2, py = 650;
          if (whiteBg) { var gg = ctx.createRadialGradient(W / 2, py + ph * 0.42, 60, W / 2, py + ph * 0.42, 980); gg.addColorStop(0, 'rgba(252,248,240,.5)'); gg.addColorStop(0.5, 'rgba(252,248,240,.17)'); gg.addColorStop(1, 'rgba(252,248,240,0)'); ctx.fillStyle = gg; ctx.fillRect(0, 0, W, H); }
          var oc = document.createElement('canvas'); oc.width = pw; oc.height = ph; var ox = oc.getContext('2d');
          var s = Math.max(pw / imgEl.width, ph / imgEl.height), dw = imgEl.width * s, dh = imgEl.height * s;
          ox.drawImage(imgEl, (pw - dw) / 2, (ph - dh) / 2, dw, dh);
          try {
            var idata = ox.getImageData(0, 0, pw, ph), d = idata.data, LO = 18, HI = 52, WLO = 150, WHI = 206;
            for (var i = 0; i < d.length; i += 4) { var lum = 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; var a = whiteBg ? (lum >= WHI ? 0 : (lum <= WLO ? 255 : (WHI - lum) / (WHI - WLO) * 255)) : (lum <= LO ? 0 : (lum >= HI ? 255 : (lum - LO) / (HI - LO) * 255)); if (a < d[i + 3]) d[i + 3] = a; }
            ox.putImageData(idata, 0, 0);
          } catch (e2) {}
          ox.globalCompositeOperation = 'destination-in';
          var mn = Math.min(pw, ph), rg = ox.createRadialGradient(pw / 2, ph / 2, mn * 0.34, pw / 2, ph / 2, mn * 0.62);
          rg.addColorStop(0, 'rgba(0,0,0,1)'); rg.addColorStop(0.82, 'rgba(0,0,0,1)'); rg.addColorStop(1, 'rgba(0,0,0,0)');
          ox.fillStyle = rg; ox.fillRect(0, 0, pw, ph);
          ctx.drawImage(oc, px, py);
        }
        ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
        var cItal = whiteBg ? '#6a6456' : '#cbc6ba', cName = whiteBg ? '#20201f' : '#ece7da', cGold = whiteBg ? '#9a7526' : '#c79a52', cWord = whiteBg ? '#315f55' : '#c79a52';
        ctx.fillStyle = cItal; ctx.font = 'italic 46px ' + serifF; ctx.fillText(useEl ? 'your colors, made real' : 'your stone, made real', W / 2, 1905);
        ctx.fillStyle = cName; ctx.font = '96px ' + serifF; ctx.fillText(useEl ? elName : stone, W / 2, 2019);
        ctx.fillStyle = cGold; ctx.font = '40px Helvetica, Arial, sans-serif';
        if ('letterSpacing' in ctx) ctx.letterSpacing = '8px';
        ctx.fillText((sign + '  ·  ' + (useEl ? ((e && e.c) ? e.c : elName) : ((BS[m] && BS[m].cl) || elName))).toUpperCase(), W / 2, 2085);
        if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
        var lw = 560, lx = (W - lw) / 2, ly = 2183, lg = ctx.createLinearGradient(lx, 0, lx + lw, 0);
        lg.addColorStop(0, 'rgba(154,117,38,0)'); lg.addColorStop(0.14, stc); lg.addColorStop(0.5, elc); lg.addColorStop(0.86, cGold); lg.addColorStop(1, 'rgba(154,117,38,0)');
        ctx.fillStyle = lg; ctx.fillRect(lx, ly, lw, 5);
        ctx.fillStyle = cWord; ctx.font = '52px ' + serifF;
        if ('letterSpacing' in ctx) ctx.letterSpacing = '3px';
        ctx.fillText('Veyamoon', W / 2, 2580);
        if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
      }
      var heWallImg = null;
      heDrawWall._g = (heDrawWall._g || 0) + 1; var __gw = heDrawWall._g;
      paint(null);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (__gw === heDrawWall._g) paint(heWallImg); });
      var imgUrl = hero && hero.images && (hero.images[0] ? (hero.images[0].src || hero.images[0]) : '');
      if (imgUrl) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { if (__gw !== heDrawWall._g) return; heWallImg = im; paint(im); }; im.onerror = function () {}; im.src = heHiRes(imgUrl); }
    }
    (function () {
      var save = root.querySelector('[data-share-save]'), copy = root.querySelector('[data-share-copy]'), nat = root.querySelector('[data-share-native]'), friend = root.querySelector('[data-share-friend]');
      function fn() { var st = window.__heFyc; return 'veyamoon-' + (((st && st.sign) || 'colors') + '').toLowerCase() + '-colors.png'; }
      if (save) save.addEventListener('click', function () { var cv = root.querySelector('.he-fyc__share-canvas'); if (!cv) return; var a = document.createElement('a'); a.download = fn(); a.href = cv.toDataURL('image/png'); document.body.appendChild(a); a.click(); document.body.removeChild(a); heTrack('he_share_save', 'FYCShareSave', { sign: (window.__heFyc || {}).sign }); });
      if (copy) copy.addEventListener('click', function () { var url = location.origin + base + '/pages/find-your-colors?utm_source=fyc_card&utm_medium=share&utm_campaign=fyc'; try { if (navigator.clipboard) navigator.clipboard.writeText(url); } catch (e) {} var o = copy.textContent; copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = o; }, 1400); heTrack('he_share_copy', 'FYCShareCopy', { sign: (window.__heFyc || {}).sign }); });
      if (nat) { if (navigator.share) nat.hidden = false; nat.addEventListener('click', function () { var cv = root.querySelector('.he-fyc__share-canvas'); if (!cv || !cv.toBlob) return; heTrack('he_share_native', 'FYCShareNative', { sign: (window.__heFyc || {}).sign }); cv.toBlob(function (blob) { try { var file = new File([blob], fn(), { type: 'image/png' }); var data = { files: [file], title: 'My colors', text: 'Find your colors at Veyamoon' }; if (navigator.canShare && navigator.canShare(data)) { navigator.share(data).catch(function () {}); } else { navigator.share({ title: 'My colors', url: base + '/pages/find-your-colors?utm_source=fyc_card&utm_medium=share&utm_campaign=fyc' }).catch(function () {}); } } catch (e) {} }, 'image/png'); }); }
      if (friend) friend.addEventListener('click', function () { if (typeof setGiftMode === 'function') setGiftMode(true); var fm = root.querySelector('.he-fyc__form'); if (fm) fm.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      var wsave = root.querySelector('[data-wall-save]'), whow = root.querySelector('[data-wall-how]');
      function wfn() { var st = window.__heFyc; return 'veyamoon-' + (((st && st.sign) || 'colors') + '').toLowerCase() + '-wallpaper.png'; }
      if (wsave) wsave.addEventListener('click', function () { var cv = root.querySelector('.he-fyc__wall-canvas'); if (!cv) return; heTrack('he_wallpaper_save', 'FYCWallpaperSave', { sign: (window.__heFyc || {}).sign }); try { if (cv.toBlob) { cv.toBlob(function (blob) { if (!blob) return; var u = URL.createObjectURL(blob); var a = document.createElement('a'); a.download = wfn(); a.href = u; document.body.appendChild(a); a.click(); document.body.removeChild(a); setTimeout(function () { URL.revokeObjectURL(u); }, 2000); }, 'image/png'); } else { var a = document.createElement('a'); a.download = wfn(); a.href = cv.toDataURL('image/png'); document.body.appendChild(a); a.click(); document.body.removeChild(a); } } catch (er) {} });
      if (whow) whow.addEventListener('click', function () { var st = root.querySelector('.he-fyc__wall-steps'); if (!st) return; var willShow = st.hidden; st.hidden = !willShow; whow.setAttribute('aria-expanded', willShow ? 'true' : 'false'); });
    })();
    (function () {
      var car = root.querySelector('[data-keep-carousel]'); if (!car) return;
      var track = car.querySelector('.he-fyc__keep-track'), slides = car.querySelectorAll('.he-fyc__keep-slide'), dots = car.querySelectorAll('[data-keep-dot]');
      var n = slides.length, idx = 0;
      function go(i) { idx = (i + n) % n; track.style.transform = 'translateX(' + (-idx * 100) + '%)'; for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j === idx); for (var s = 0; s < slides.length; s++) { var on = s === idx; slides[s].setAttribute('aria-hidden', on ? 'false' : 'true'); var fs = slides[s].querySelectorAll('a, button'); for (var q = 0; q < fs.length; q++) fs[q].tabIndex = on ? 0 : -1; } }
      var prev = car.querySelector('[data-keep-prev]'), next = car.querySelector('[data-keep-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      for (var d = 0; d < dots.length; d++) (function (k) { dots[k].addEventListener('click', function () { go(k); }); })(d);
      var view = car.querySelector('.he-fyc__keep-view'), x0 = null;
      if (view) { view.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true }); view.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1); x0 = null; }); }
      car.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(idx - 1); else if (e.key === 'ArrowRight') go(idx + 1); });
      go(0);
    })();

    /* 礼物态：同一个 hero 输入框切换 me / them（relabel + 按钮文案 + 揭示用 gift 人称） */
    var gmOnBtn = root.querySelector('[data-giftmode-on]');
    var gmOffBtn = root.querySelector('[data-giftmode-off]');
    var gmActive = root.querySelector('[data-giftmode-active]');
    var gmHint = root.querySelector('[data-giftmode-hint]');
    var gmJump = root.querySelector('[data-giftmode-jump]');
    var gmJumpPre = root.querySelector('[data-gift-prefix]');
    var goBtn = root.querySelector('.he-fyc__go');
    var goDefault = goBtn ? goBtn.textContent.trim() : 'Reveal my colors';
    var lblMonth = root.querySelector('.he-fyc__flabel-month');
    var lblDay = root.querySelector('.he-fyc__flabel-day');
    var heroForm = root.querySelector('.he-fyc__form');

    /* ── Hero 上半部分的"你 → 他"改写 ──
       🔴 这一层原来根本没接进礼物态：eyebrow / 大标题 / 副标题在礼物态下
       仍然全是 "your/you"，顾客切到"给别人找"之后读到的还是"发现**你的**颜色"。
       不硬编码 their 版文案 —— 那样商家在后台改一次标题就失效了。
       改成从 DOM 存下自己态原文，礼物态用词替换生成，商家怎么改都跟得上。
       ⚠️ 小写 you → them（宾格，本页 "worn for you" 这类都是宾格）；
       大写 You → They（主格）。这是按现有文案定的，将来加主格小写 you 要另外处理。 */
    function toTheirs(t) {
      return String(t)
        .replace(/\bYou're\b/g, "They're").replace(/\byou're\b/g, "they're")
        .replace(/\bYours\b/g, 'Theirs').replace(/\byours\b/g, 'theirs')
        .replace(/\bYour\b/g, 'Their').replace(/\byour\b/g, 'their')
        .replace(/\bYou\b/g, 'They').replace(/\byou\b/g, 'them');
    }
    var heroSwap = ['.he-fyc__eyebrow', '.he-fyc__title', '.he-fyc__sub'].map(function (sel) {
      var el = root.querySelector(sel);
      return el ? { el: el, self: el.textContent, gift: toTheirs(el.textContent) } : null;
    }).filter(Boolean);
    var chartCta = root.querySelector('[data-chart-cta]');

    function setGiftMode(on) {
      giftModeOn = on;
      heroSwap.forEach(function (o) { o.el.textContent = on ? o.gift : o.self; });
      /* 礼物态隐藏星盘入口：送礼的人拿不到对方的出生时刻和城市 */
      if (chartCta) chartCta.hidden = on;
      if (lblMonth) lblMonth.textContent = on ? 'Their month' : 'Birth month';
      if (lblDay) lblDay.textContent = on ? 'Their day' : 'Birth day';
      if (goBtn) goBtn.textContent = on ? 'Reveal their colors' : goDefault;
      if (gmOnBtn) { gmOnBtn.hidden = on; gmOnBtn.setAttribute('aria-expanded', on ? 'true' : 'false'); }
      if (gmActive) gmActive.hidden = !on;
      if (gmHint) gmHint.hidden = !on;
      if (heroForm) heroForm.classList.toggle('is-gift', on);
      if (gmJumpPre) gmJumpPre.textContent = on ? 'Finding for yourself? ' : 'Shopping for someone? ';
      if (gmJump) gmJump.textContent = on ? 'Find your colors by birthday →' : 'Find their colors by birthday →';
    }
    if (gmOnBtn) gmOnBtn.addEventListener('click', function () { setGiftMode(true); });
    if (gmJump) gmJump.addEventListener('click', function (e) {
      e.preventDefault();
      setGiftMode(!giftModeOn);
      var ms = root.querySelector('.he-fyc__month');
      if (ms) ms.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    if (gmOffBtn) gmOffBtn.addEventListener('click', function () { setGiftMode(false); });

    /* 从首页礼物链 ?for=gift 进入 → 自动开礼物态 */
    try { if (/[?&]for=gift\b/.test(window.location.search)) setGiftMode(true); } catch (e) {}

    /* 刻意：表单每次打开都保持空白初始态（不从 sessionStorage 还原生日）——用户必须主动输入。
       邮箱提交走 AJAX 不刷新页面，故无需"刷新后还原结果"的旧逻辑。 */

    /* —— Sprint 3 数据线：邮箱 + 生日 → Klaviyo profile property（装了 Klaviyo 才生效，否则静默）+ Shopify 月份/星座标签 —— */
    function heKlaviyoIdentify(email) {
      if (!email) return;
      var ctx = window.__heFyc;
      var props = { '$email': email, 'email': email };
      if (ctx) {
        /* 完整 ISO 8601 datetime（带时区）——Klaviyo 只有见到这种格式才会把属性识别成"日期"，日期流触发器才选得到；裸 '2000-10-15' 会被存成文本。年份 2000 是占位，日期流按"每年周年"触发会忽略年份。 */
        var iso = '2000-' + ('0' + ctx.m).slice(-2) + '-' + ('0' + ctx.d).slice(-2) + 'T00:00:00+00:00';
        if (ctx.gift) {
          /* 礼物态：写"收礼人"独立数据线（GiftBirthday），绝不碰买家自己的 Birthday —— 生日库提醒流靠 GiftBirthday 触发 */
          props.GiftRecipientMonth = ctx.m; props.GiftBirthday = iso; props.GiftRecipientStone = ctx.stone; props.GiftRecipientSign = ctx.sign;
        } else {
          /* 自己态：写买家本人的生日线 */
          props.BirthMonth = ctx.m; props.BirthDay = ctx.d; props.Zodiac = ctx.sign; props.Birthstone = ctx.stone; props.ZodiacElement = ctx.element; props.Birthday = iso;
        }
      }
      try {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') { window.klaviyo.identify(props); }
        else { window._learnq = window._learnq || []; window._learnq.push(['identify', props]); }
      } catch (e) {}
    }
    var saveForm = root.querySelector('.he-fyc__save-form');
    if (saveForm) {
      saveForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = saveForm.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email || (emailInput.checkValidity && !emailInput.checkValidity())) {
          if (emailInput && emailInput.reportValidity) emailInput.reportValidity();
          return;
        }
        /* 把测验生日写进标签（服务端可靠，Klaviyo 会同步 Shopify 标签）；礼物态用 gift-* 标签，和买家自己的月份标签分开 */
        var ctx = window.__heFyc;
        var tagsInput = saveForm.querySelector('.he-fyc-tags');
        if (tagsInput && ctx && ctx.m) {
          var baseTags = tagsInput.getAttribute('data-base-tags') || 'newsletter,fyc';
          tagsInput.value = ctx.gift
            ? baseTags + ',gift-reminder,gift-bmonth-' + ctx.m
            : baseTags + ',bmonth-' + ctx.m + ',zodiac-' + String(ctx.sign || '').toLowerCase() + ',element-' + String(ctx.element || '').toLowerCase();
        }
        var okEl = root.querySelector('.he-fyc__save-ok');
        var errEl = root.querySelector('.he-fyc__save-err');
        if (errEl) errEl.hidden = true;
        var btn = saveForm.querySelector('button[type="submit"]');
        var __btnLabel = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }
        saveForm.setAttribute('aria-busy', 'true');
        /* 生日属性先落库：Klaviyo identify 是独立 onsite 调用，不依赖 Shopify /contact 是否 302。
           先 identify → 生日/星座/生辰石 100% 进 Klaviyo profile，不被 Shopify 的 200 JSON 回包 / 302 差异 / 限流静默吞掉。 */
        heKlaviyoIdentify(email);
        heTrack('he_email_save', 'FYCEmailSave', { sign: (window.__heFyc || {}).sign });
        saveForm.removeAttribute('aria-busy');
        if (btn) { btn.disabled = false; btn.textContent = __btnLabel; }  /* 兜底复位按钮：即使表单没能隐藏，也绝不卡在 Saving… */
        saveForm.hidden = true;
        if (okEl) { okEl.hidden = false; try { okEl.setAttribute('tabindex', '-1'); okEl.focus(); } catch (er) {} }
        if (errEl) errEl.hidden = true;
        /* Shopify customer 记录尽力落库（去掉 Accept:json，走标准 302）；成功与否，生日都已进 Klaviyo。 */
        fetch(saveForm.action, { method: 'POST', body: new FormData(saveForm) }).catch(function () {});
      });
    }

    /* —— 收礼人生日（GiftBirthday）已并入上面的存色板表单（方案 A）：礼物态提交时 heKlaviyoIdentify 走 ctx.gift 分支写 GiftBirthday。
       原独立 .he-fyc__giftremind-form 从未渲染进页面（只有 CSS/占位类），旧 handler 已移除，避免两条并行的收礼人采集路径。 —— */

    /* —— 星点：进视口才跑，出视口暂停（性能）；尊重 reduced-motion —— */
    var canvas = root.querySelector('.he-fyc__stars');
    if (canvas && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var ctx = canvas.getContext('2d');
      var dots = [], raf = null, running = false;
      function resize() {
        var r = canvas.getBoundingClientRect();
        canvas.width = r.width; canvas.height = r.height;
        var count = Math.min(120, Math.round(r.width * r.height / 9000));
        dots = [];
        for (var i = 0; i < count; i++) {
          dots.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            r: Math.random() * 1.6 + 0.4,
            a: Math.random(),
            s: Math.random() * 0.02 + 0.004,
            vy: Math.random() * 0.12 + 0.02
          });
        }
      }
      function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        for (var i = 0; i < dots.length; i++) {
          var p = dots[i];
          p.a += p.s; if (p.a > 1 || p.a < 0) p.s = -p.s;
          p.y -= p.vy; if (p.y < 0) p.y = canvas.height;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(244,239,231,' + (Math.abs(p.a) * 0.7 + 0.1) + ')';
          ctx.fill();
        }
        raf = requestAnimationFrame(draw);
      }
      function start() { if (!running) { running = true; resize(); draw(); } }
      function stop() { running = false; if (raf) cancelAnimationFrame(raf); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { start(); } else { stop(); } });
        }, { threshold: 0.05 }).observe(canvas);
      } else { start(); }
      window.addEventListener('resize', function () { if (running) resize(); });
    }

    /* —— 下半部滚动入场：渐进增强（无 JS / headless 内容照常可见），尊重 reduced-motion —— */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('is-reveal-ready');
      var revealEls = root.querySelectorAll('.he-fyc__reveal, .he-fyc__stagger');
      if ('IntersectionObserver' in window) {
        var rio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            var t = en.target;
            if (t.classList.contains('he-fyc__stagger')) {
              for (var s = 0; s < t.children.length; s++) { t.children[s].style.setProperty('--i', s); }
            }
            t.classList.add('is-in');
            rio.unobserve(t);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        for (var ri = 0; ri < revealEls.length; ri++) { rio.observe(revealEls[ri]); }
      } else {
        for (var rj = 0; rj < revealEls.length; rj++) { revealEls[rj].classList.add('is-in'); }
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["he-gift-birthday"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.he-gb').forEach(function (gb) {
  if (gb.dataset.gbInit) return; gb.dataset.gbInit = '1';
  var btns = gb.querySelectorAll('[data-gb-mode]');
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var mode = b.getAttribute('data-gb-mode');
      btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      gb.querySelectorAll('[data-gb-grid]').forEach(function (g) { g.hidden = (g.getAttribute('data-gb-grid') !== mode); });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
